import React, { useState } from 'react';
import styles from './Group.module.scss';
import SpriteFrame from 'components/editor/SpriteFrame';
import { inject } from 'mobx-react';
import { EDITOR_GROUPS_STORE } from 'store';
import NameInput from './NameInput';
import { observer } from 'mobx-react-lite';
import { GroupProps } from './types';

const Group = (props: GroupProps) => {
  const {
    name = '<< unnamed >>',
    previewFrame = 1,
    shotIds = [],
    shotsNumber = shotIds.length,
    [EDITOR_GROUPS_STORE]: { switchGroupSelection, isGroupSelected },
    isSelected = isGroupSelected(name),
    singleSelect = false,
    onClick = () => switchGroupSelection(name, singleSelect),
    disableNameEdit = false
  } = props;

  const [editName, setEditName] = useState(false);

  const handleNameClick = e => {
    e.stopPropagation();
    if (name === '<1sec' || disableNameEdit) return;
    setEditName(true);
  };

  return (
    <div className={styles.container} onClick={onClick}>
      {/* {console.count('GROUP ' + name)} */}
      <SpriteFrame frameNumber={previewFrame} />
      {isSelected && <div className={styles.selectedIndication} />}
      <span
        onClick={handleNameClick}
        title='Change group name'
      >
        {editName
          ? <NameInput name={name} onClose={() => setEditName(false)} />
          : name}
      </span>
      <span>{shotsNumber} shots</span>
    </div>
  );
};

const arePropsEqual = (prevProps, nextProps) => {
  if (prevProps.isSelected !== nextProps.isSelected) return false;
  if (prevProps.shotsNumber !== nextProps.shotsNumber) return false;
  if (prevProps.previewFrame !== nextProps.previewFrame) return false;
  if (prevProps.name !== nextProps.name) return false;
  return true;
};

export default React.memo(inject(EDITOR_GROUPS_STORE)(observer(Group)), arePropsEqual);
